
import { Component, Vue } from "vue-property-decorator";
import { MetaInfo } from "vue-meta";

interface ProBenefit {
  title: string;
  description: string;
  icon: string;
}

interface ProFaq {
  question: string;
  answer: string;
}

interface ProUpgradeStep {
  id: number;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
}

@Component
export default class ProMember extends Vue {
  proUpgradeUrl = "https://fdtigermasterpro.page.link/DynamicLink";

  upgradeSteps: ProUpgradeStep[] = [
    {
      id: 1,
      title: "前往「帳號」",
      description: "點選 App 右下角「帳號」。",
      image: "/fdtiger-offical-site-img/pro-member/upgrade-step-01.webp",
      imageAlt: "師虎來了 App 首頁，帳號按鈕位於右下角",
    },
    {
      id: 2,
      title: "升級 Pro 會員",
      description: "點選右上角「升級 Pro 會員」。",
      image: "/fdtiger-offical-site-img/pro-member/upgrade-step-02.webp",
      imageAlt: "師虎來了 App 帳號頁面的升級 Pro 會員按鈕",
    },
    {
      id: 3,
      title: "確認並完成升級",
      description: "確認權益與費用，完成付款即升級成功。",
      image: "/fdtiger-offical-site-img/pro-member/upgrade-step-03.webp",
      imageAlt: "師虎 Pro 會員權益頁面的立即升級按鈕",
    },
  ];

  benefits: ProBenefit[] = [
    {
      title: "終生免派遣費",
      description: "每年 6 次免費勘查報價，家中大小工程都能安心處理",
      icon: "/fdtiger-offical-site-img/pro-member/benefit-seal.svg",
    },
    {
      title: "送 $4,000 修繕金",
      description:
        "升級即贈 4,000 點 TIGER POINTS，等同 $4,000 修繕金，可直接折抵訂單費用 (1點折抵1元)",
      icon: "/fdtiger-offical-site-img/pro-member/benefit-coins.svg",
    },
    {
      title: "商城專屬優惠",
      description: "嚴選商品享有 Pro 會員專屬優惠",
      icon: "/fdtiger-offical-site-img/pro-member/benefit-tote.svg",
    },
  ];

  faqs: ProFaq[] = [
    {
      question: "Pro 會員有什麼優惠？",
      answer:
        "成為 Pro 會員後，享有每一會員年度 6 次免派遣費及 TIGER POINTS 贈品等相關專屬優惠。",
    },
    {
      question: "免派遣費優惠如何使用？",
      answer:
        "您的叫修訂單在媒合師傅成功後，平台系統會自動代入優惠，免除支付派遣費，直接安排師傅勘場、評估與報價。",
    },
    {
      question: "TIGER POINTS 可以做什麼用？",
      answer:
        "TIGER POINTS 為平台贈與之優惠點數，可以折抵本平台修繕訂單尾款或商城商品消費。",
    },
    {
      question: "Pro 會員可以退費嗎？",
      answer:
        "退費標準依據《消費者保護法》與平台服務條款辦理：\n1.全額退費：購買後 7 日內，且完全未使用過任何權益（含領取修繕金、實際叫修）。\n2.比例退費：購買逾 7 日或已使用部分權益者，申請退費時須扣除行政規費 (NT$300)、已領取點數及已使用之優惠價值。若剩餘價值為負數，則不予退費。",
    },
  ];

  metaInfo(): MetaInfo {
    const title = "師虎來了 Pro 會員";
    const description =
      "升級師虎來了 Pro 會員，一次付費即享每一會員年度 6 次免派遣費、4,000 點 TIGER POINTS 回饋，以及商城專屬優惠，立即下載 App 了解更多。";
    const url = "https://www.fdtigermaster.com/pro-member";

    return {
      title,
      meta: [
        { vmid: "description", name: "description", content: description },
        { vmid: "og:title", property: "og:title", content: title },
        {
          vmid: "og:description",
          property: "og:description",
          content: description,
        },
        { vmid: "og:type", property: "og:type", content: "website" },
        { vmid: "og:url", property: "og:url", content: url },
      ],
      link: [{ vmid: "canonical", rel: "canonical", href: url }],
    };
  }
}
